export const COMPONENT_NAME = 'OperatingHours';
